import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer } from 'react-relay';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { FormattedPrice } from '../../misc';
import { FormattedMessageWrappedInSpan } from '../../misc';
import { CopyToClipboardIcon } from '../../misc/Buttons';

import { Launch } from '@carbon/icons-react';

const GiftcardCard = (props) => {
  const { eventName, eventId, eventBanner } = props;
  const { giftcards } = props.viewer.account.eventPurchases;

  return (
    <div key={eventId}>
      {giftcards.map((giftcardData) => {
        return (
          <div className="giftcard-card col-sm-8 col-xs-16 mb-20" key={giftcardData.code}>
            <div className="giftcard-card_banner">
              {eventBanner && <img src={eventBanner} />}
            </div>
            <div className="giftcard-card_info">
              <Link to={`/event/${eventId}`}>
                <div className="giftcard-card_info_name">
                  <span>{eventName}</span>
                  <span className="giftcard-card_icon">
                    <Launch size={24} />
                  </span>
                </div>
              </Link>
              <div className="giftcard-card_info_details">
                <div className="giftcard-card_info_details_detail-frame">
                  <FormattedMessageWrappedInSpan
                    id="giftcardCard.value"
                    defaultMessage="Value"
                  />
                  <span>
                    <FormattedPrice price={giftcardData.initialValue} />
                  </span>
                </div>
                <div className="giftcard-card_info_details_detail-frame">
                  <FormattedMessageWrappedInSpan
                    id="giftcardCard.code"
                    defaultMessage="Code"
                  />
                  <span className="giftcard-card_text_with_icon">
                    <div>{giftcardData.code}</div>
                    <CopyToClipboardIcon stringToCopy={giftcardData.code} />
                  </span>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

GiftcardCard.propTypes = {
  eventId: PropTypes.string,
  eventBanner: PropTypes.string,
  eventName: PropTypes.string,
};

export { GiftcardCard };

export default createFragmentContainer(injectIntl(GiftcardCard), {
  viewer: graphql`
    fragment GiftcardCard_viewer on Viewer {
      account {
        eventPurchases(byStartnumber: true, eventId: $eventId) {
          giftcards {
            code
            initialValue
          }
        }
      }
    }
  `,
});
